const formatCurrency = (value) => {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}K`;
  }
  return `${value}`;
};

const TopMetrics = (props) => {
  return <div className="relative h-64">
    <div className="absolute w-96 h-96 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-full blur-3xl"></div>
    <h2 className="text-2xl mb-4">Financial Metrics</h2>
    <div className="grid grid-cols-2 gap-4 h-full pb-10">
      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-4 rounded-2xl">
        <div className="text-2xl font-bold mb-2 text-white">{formatCurrency(props.headerMetrics.totalRevenue)}</div>
        <div className="text-slate-400 text-sm">Total Revenue</div>
      </div>

      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-4 rounded-2xl">
        <div className="text-2xl font-bold mb-2 text-white">{formatCurrency(props.headerMetrics.totalCogs)}</div>
        <div className="text-slate-400 text-sm">Total COGs</div>
      </div>

      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-4 rounded-2xl">
        <div className="text-2xl font-bold mb-2 text-green-400">{formatCurrency(props.headerMetrics.totalProfit)}<span className="text-green-400 text-2xl mr-2">▲</span></div>
        <div className="text-slate-400 text-sm">Total Profit</div>
      </div>

      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-4 rounded-2xl">
        <div className="text-2xl font-bold mb-2 text-white">{props.headerMetrics.roi}</div>
        <div className="text-slate-400 text-sm">Return of investments</div>
      </div>
    </div>
  </div>
}

export default TopMetrics;
